import M from "moment/moment";
import * as R from "ramda";
import {flattenFormGroupObject, getValueFromDDL, mapToObjectDDL} from "../../../common/mapper";
import moment from "moment";
import {base64ToFile} from "../../../../Services/Utils";

export const initialData = (data, user, id, tab) => {
    const {
        processBbnDetailId = "",
        processBbnId = "",
        receiverType = "",
        receiverName = "",
        nik = "",
        noWa = "",
        noHp = "",
        address = "",
        documentCode = "",
        province = null,
        kabKot = null,
        kecamatan = null,
        kelurahan = null,
        zipCode = null,
        receiverPhoto = "",
        idPhoto = "",
        suratKuasa = "",
        sidikJari = "",
        staff = "",
        date = "",
        time = "",
    } = data ?? {};

    return {
        processBbnDetailId: R.isEmpty(processBbnDetailId) ? "" : processBbnDetailId,
        processBbnId: R.isEmpty(processBbnId) ? id : processBbnId,
        receiverType: R.isEmpty(receiverType) ? tab : receiverType,
        receiverName: R.isEmpty(receiverName) ? "" : receiverName,
        nik: R.isEmpty(nik) ? "" : nik,
        noWa: R.isEmpty(noWa) ? "" : noWa,
        noHp: R.isEmpty(noHp) ? "" : noHp,
        address: R.isEmpty(address) ? "" : address,
        documentCode: R.isEmpty(documentCode) ? "" : documentCode,
        province: R.isNil(province) ? null : mapToObjectDDL(province?.provinceName, province?.id),
        kabKot: R.isNil(kabKot) ? null : mapToObjectDDL(kabKot?.kabKotName, kabKot?.kabKotId),
        kecamatan: R.isNil(kecamatan) ? null : mapToObjectDDL(kecamatan?.kecamatanName, kecamatan?.id),
        kelurahan: R.isNil(kelurahan) ? null : mapToObjectDDL(kelurahan?.kelurahanname, kelurahan?.id),
        zipCode: R.isNil(zipCode) ? null : mapToObjectDDL(zipCode, zipCode),
        receiverPhoto: R.isEmpty(receiverPhoto) ? "" : receiverPhoto,
        idPhoto: R.isEmpty(idPhoto) ? "" : idPhoto,
        suratKuasa: R.isEmpty(suratKuasa) ? "" : suratKuasa,
        sidikJari: R.isEmpty(sidikJari) ? "" : sidikJari,
        staffId: R.isNil(staff) ? (mapToObjectDDL(user?.user?.username, user?.user?.idUser)) : mapToObjectDDL(staff?.name, staff?.idUser),
        date: R.isNil(date) ? M(new Date()).format("DD-MM-YYYY") : date,
        time: R.isNil(time) ? moment(new Date()).format("HH:mm") : moment(time, "HH:mm:ss").format("HH:mm"),
    }
}

export const validate = (controls, isReceivingSalesmanSelected, tab, selReceiver) => {
    let column = [];
    const newErrors = {};

    if (R.equals(tab, "BPKB")) {
        if (R.isNil(selReceiver)) {
            newErrors["selReceiver"] = "Field harus diisi";
            return newErrors;
        }

        if (R.equals(selReceiver?.value, "PEMILIK_STNK")) {
            column = ["receiverPhoto", "idPhoto", "sidikJari"]
        } else if (R.equals(selReceiver?.value, "PETUGAS")) {
            column = ["null"];
        }
    } else {
        if (isReceivingSalesmanSelected) {
            column = ["receiverPhoto", "idPhoto"];
        }
    }


    if (controls) {
        for (const [key, data] of Object.entries(controls)) {
            if (column.length === 0 || column.includes(key)) {
                if (data) {
                    const message = validateEmptyValue(data);
                    if (message) {
                        newErrors[key] = message;
                    }
                }
            }
        }
    }
    return newErrors;
}

function validateEmptyValue(data) {
    if (R.and(data.mandatory, R.or(!data.value, R.isEmpty(data.value)))) {
        return "Field belum diisi";
    }

    return null;
}

export const constructFormData2 = (controls, isReceivingSalesmanSelected, tab, selReceiver) => {
    let formData = new FormData();
    const formGroup = flattenFormGroupObject(controls);
    const {idPhoto, receiverPhoto, suratKuasa, sidikJari} = formGroup;
    const requestPayload = {
        ...formGroup,
        province: getValueFromDDL(formGroup, "province"),
        city: getValueFromDDL(formGroup, "kabKot"),
        kecamatan: getValueFromDDL(formGroup, "kecamatan"),
        kelurahan: getValueFromDDL(formGroup, "kelurahan"),
        zipCode: getValueFromDDL(formGroup, "zipCode"),
        staffId: getValueFromDDL(formGroup, "staffId"),
    }

    // Define base payload structure
    let payload = {
        staffId: requestPayload.staffId,
        date: requestPayload.date,
        time: requestPayload.time,
        receiverType: requestPayload.receiverType,
        processBbnId: requestPayload.processBbnId,
        processBbnDetailId: requestPayload.processBbnDetailId,
    };

    // Handle different conditions
    if (!R.equals(tab, "BPKB") && isReceivingSalesmanSelected) {
        formData.append("data", new Blob([JSON.stringify(payload)], {type: "application/json"}));
        formData.append("idPhoto", base64ToFile(idPhoto, "idPhoto", "image/jpeg"));
        formData.append("receiverPhoto", base64ToFile(receiverPhoto, "receiverPhoto", "image/jpeg"));
        return formData;
    }

    if (selReceiver?.value === "PEMILIK_STNK") {
        formData.append("data", new Blob([JSON.stringify(payload)], {type: "application/json"}));
        formData.append("idPhoto", base64ToFile(idPhoto, "idPhoto", "image/jpeg"));
        formData.append("receiverPhoto", base64ToFile(receiverPhoto, "receiverPhoto", "image/jpeg"));
        formData.append("sidikJari", base64ToFile(sidikJari, "sidikJari", "image/jpeg"));
        return formData;
    }

    if (selReceiver?.value === "PETUGAS") {
        formData.append("data", new Blob([JSON.stringify(payload)], {type: "application/json"}));
        return formData;
    }

    delete requestPayload.kabKot;
    delete requestPayload.idPhoto;
    delete requestPayload.receiverPhoto;
    delete requestPayload.suratKuasa;
    delete requestPayload.sidikJari;

    formData.append("data", new Blob([JSON.stringify(requestPayload)], {type: "application/json"}));
    formData.append("idPhoto", base64ToFile(idPhoto, "idPhoto", "image/jpeg"));
    formData.append("receiverPhoto", base64ToFile(receiverPhoto, "receiverPhoto", "image/jpeg"));
    if (R.equals(tab, "BPKB")) {
        formData.append("suratKuasa", base64ToFile(suratKuasa, "suratKuasa", "image/jpeg"));
        formData.append("sidikJari", base64ToFile(sidikJari, "sidikJari", "image/jpeg"));
    }

    return formData
}

export const constructFormData = (controls, isReceivingSalesmanSelected, tab, selReceiver) => {
    const formGroup = flattenFormGroupObject(controls);

    let requestPayload = {
        ...formGroup,
        province: getValueFromDDL(formGroup, "province"),
        city: getValueFromDDL(formGroup, "kabKot"),
        kecamatan: getValueFromDDL(formGroup, "kecamatan"),
        kelurahan: getValueFromDDL(formGroup, "kelurahan"),
        zipCode: getValueFromDDL(formGroup, "zipCode"),
        staffId: getValueFromDDL(formGroup, "staffId"),
    };

    // Remove "kabKot" field
    delete requestPayload.kabKot;

    // Define base payload structure
    let payload = {
        staffId: requestPayload.staffId,
        date: requestPayload.date,
        time: requestPayload.time,
        receiverType: requestPayload.receiverType,
        processBbnId: requestPayload.processBbnId,
        processBbnDetailId: requestPayload.processBbnDetailId,
    };

    // Handle different conditions
    if (!R.equals(tab, "BPKB") && isReceivingSalesmanSelected) {
        return {...payload, receiverPhoto: requestPayload.receiverPhoto, idPhoto: requestPayload.idPhoto};
    }

    if (R.equals(tab, "BPKB") && selReceiver?.value === "PEMILIK_STNK") {
        return {
            ...payload,
            receiverPhoto: requestPayload.receiverPhoto,
            idPhoto: requestPayload.idPhoto,
            sidikJari: requestPayload.sidikJari
        };
    }

    if (R.equals(tab, "BPKB") && selReceiver?.value === "PETUGAS") {
        return payload;
    }

    // Remove unnecessary fields for non-"BPKB" tab
    if (!R.equals(tab, "BPKB")) {
        delete requestPayload.documentCode;
        delete requestPayload.suratKuasa;
        delete requestPayload.sidikJari;
    }

    return requestPayload;
};


export const hidden = (isReceivingSalesmanSelected, selReceiver, tab) => {
    if (R.equals(tab, "BPKB")) {
        if (R.isNil(selReceiver)) {
            return true;
        } else if (R.equals(selReceiver?.value, "BUKAN_PEMILIK_STNK")) {
            return true;
        } else if (R.or(R.equals(selReceiver?.value, "PETUGAS"), R.equals(selReceiver?.value, "PEMILIK_STNK"))) {
            return false;
        }
    }

    return !isReceivingSalesmanSelected;
}

export const hiddenFileImage = (selReceiver, tab) => {
    if (R.equals("BPKB", tab)) {
        if (!R.isNil(selReceiver) && R.equals(selReceiver?.value, "PETUGAS")) {
            return false
        }
    }
    return true;
}

export const resetIgnoreKeys = (isReceivingSalesmanSelected, selReceiver, tab, props) => {
    if (R.equals(tab, "BPKB")) {
        if (R.equals(selReceiver?.value, "PEMILIK_STNK")) {
            props.resetIgnoreKeys(["staffId", "date", "time", "receiverType", "processBbnId", "receiverPhoto", "idPhoto", "suratKuasa", "sidikJari"]);
        } else if (R.equals(selReceiver?.value, "PETUGAS")) {
            props.resetIgnoreKeys(["staffId", "date", "time", "receiverType", "processBbnId"]);
        }

    } else {
        if (isReceivingSalesmanSelected) {
            props.resetIgnoreKeys(["staffId", "date", "time", "receiverType", "processBbnId", "receiverPhoto", "idPhoto", "suratKuasa", "sidikJari"]);
        }
    }
}

export const getDefaultSelReceiver = (detail) => {
    if (R.and(!R.isNil(detail?.receiverName), !R.isEmpty(detail?.receiverName))) {
        return {label: "Bukan Pemilik STNK", value: "BUKAN_PEMILIK_STNK"};
    } else if (R.and(!R.isNil(detail?.idPhoto), !R.isEmpty(detail?.idPhoto), R.or(R.isNil(detail?.suratKuasa), R.isEmpty(detail?.suratKuasa)))) {
        return {label: "Pemilik STNK", value: "PEMILIK_STNK"};
    } else {
        return {label: "Petugas", value: "PETUGAS"};
    }
}

export const constructPayloadExport = (controls, dataTable) => {
    return {
        handOverNumber: controls.handOverNumber.value,
        periodHandOver: controls.periodHandOver.value,
        leasing: {
            leasingId: controls.leasingId.value?.value,
            leasingName: controls.leasingId.value?.label
        },
        receiptName: controls.receiptName.value,
        contactNumber: controls.contactNumber.value,
        jabatan: controls.jabatan.value,
        detail: dataTable.map(({bpkbStatus, numberBPKB, pencairan, ...item}) => ({
            ...item,
            leasingId: controls.leasingId.value?.value
        })),
        leasingEmployeeId: controls.idPegawai.value
    }
}

export function downloadPdf(blob, fileName) {
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export async function printPDF(data) {
  try {
    const blobUrl = URL.createObjectURL(data);

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    printWindow.document.write(`
          <html>
            <head>
              <title>Print PDF</title>
              <link rel="icon" type="image/x-icon" href="/iconnagamas.ico" />
              <style>
                html, body { margin: 0; padding: 0; height: 100%; overflow: hidden; }
                iframe { width: 100%; height: 100%; border: none; }
              </style>
            </head>
            <body>
              <iframe id="pdfFrame" src="${blobUrl}"></iframe>
              <script>
                const iframe = document.getElementById('pdfFrame');
                iframe.onload = function () {
                  setTimeout(() => {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                  }, 500);
                };
              </script>
            </body>
          </html>
        `);

    printWindow.document.close();
  } catch (error) {
    console.error("Failed to load or print PDF Blob:", error);
  }
};